
/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'arrows2': {
    width: 16,
    height: 16,
    viewBox: '0 0 14 14',
    data: '<path pid="0" d="M11.128 4.143c-1.535 1.579-5.934 6.045-6.906 7.069L7 14H0l.026-7 2.837 2.847 6.91-7.064L7 0h7l-.026 7z" _fill="#d9d9d9" fill-rule="evenodd"/>'
  }
})
